export const svgAnimatedBackground = `<svg
  width="1920"
  height="960"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
<style type="text/css">
.svg-bg-img {transform: translateY(37px);}
.svg-bg-img *{transition: all 3s;}
.house{opacity: .56;}
.animate-active .house{opacity: 1;}
.orange-pipe{stroke:#F4E4D7;stroke-width:20;}
.animate-active .orange-pipe{stroke:#F196A5}
.animate-active #cloud-blue{transform: translateX(24px);}
.animate-active #cloud-red{transform: translateX(-6px);}
.animate-active .dots__first{transform: translateY(16px);}
.animate-active .dots__second{transform: translateY(-16px);}
.animate-active #smoke{transform: skewX(8deg) translateX(-68px);}
.animate-active .dots2__first-line{transform: translateY(16px);}
.animate-active .dots2__second-line{transform: translateY(-24px);}

</style>
  <g id="image background v3" opacity=".8" clip-path="url(#clip0_12981_195183)" class="svg-bg-img">
    <g opacity=".56">
      <g>
        <path
          id="Vector 956"
          d="M575 850h110"
          stroke="#F196A5"
          stroke-width="50"
        />
        <path
          class="orange-pipe"
          d="M982 761h490"
        />
        <path
          id="Vector 959"
          d="M822 769v-39c0-12.15 9.85-22 22-22h23c12.15 0 22 9.85 22 22v147c0 12.15 9.85 22 22 22h72"
          stroke="url(#paint0_linear_12981_195183)"
          stroke-width="20"
        />
        <path
          class="orange-pipe"
          d="M1023.38 521v415"
        />
        <path
          class="orange-pipe"
          d="M983 521v415"
        />
        <path
          id="Vector 957 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M830.227 748c4.97 0 9 4.029 9 9v32.574c0 52.09-42.316 94.318-94.516 94.318H688c-4.971 0-9-4.03-9-9v-50.269c0-4.97 4.029-9 9-9h56.711c14.417 0 26.104-11.663 26.104-26.049V757c0-4.971 4.03-9 9-9h50.412Z"
          fill="#F7CFD5"
        />
        <path
          id="Vector 958"
          d="M789.338 767.126v-86.087c0-33.137 26.863-60 60-60h186.952c33.14 0 60-26.863 60-60V521"
          stroke="#F7CFD5"
          stroke-width="20"
        />
      </g>
      <path
        id="Union"
        d="M890.13 581.128c-.973-1.636-2.738-2.638-4.644-2.638h-9.492c-2.983 0-5.401 2.413-5.401 5.389v9.712c0 2.977 2.418 5.39 5.401 5.39h16.416v6.403h-17.309c-.991-1.175-2.475-1.921-4.134-1.921h-3.315c-2.983 0-5.401 2.413-5.401 5.39v24.44c0 2.976 2.418 5.389 5.401 5.389h3.315c1.659 0 3.143-.746 4.134-1.921h68.324l.581 2.321c.601 2.4 2.761 4.083 5.24 4.083h3.116c2.479 0 4.639-1.683 5.24-4.083l1.544-6.163v-23.693l-1.544-6.163c-.601-2.399-2.761-4.083-5.239-4.083h-3.117c-2.478 0-4.638 1.684-5.239 4.083l-.582 2.321h-34.331v-6.403h16.417c2.983 0 5.401-2.413 5.401-5.39v-9.712c0-2.976-2.418-5.389-5.401-5.389h-9.492c-1.906 0-3.671 1.002-4.644 2.638l-3.003 5.046h-15.24l-3.002-5.046Z"
        stroke="#E14761"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <g>
      <g id="smoke">
        <path
          d="M-55.0635 468.078C-95.574 347.155 189.18 243.721 221.824 337.161 254.468 430.602 376 361.989 376 482.329c0 0-35.924-20.865-95.05 64.14s-295.5029 42.532-336.0135-78.391Z"
          fill="url(#paint1_linear_12981_195183)"
        />
      </g>
      <g>
        <path id="Vector_2" d="M327 483h-14v28h14v-28Z" fill="#F196A5" />
        <path id="Vector_3" d="M327 511h-14v28h14v-28Z" fill="#FBE9EC" />
        <path id="Vector_4" d="M327 540h-14v28h14v-28Z" fill="#F196A5" />
        <path id="Vector_5" d="M327 568h-14v28h14v-28Z" fill="#FBE9EC" />
      </g>
      <g>
        <path id="Vector_6" d="M376 483h-14v28h14v-28Z" fill="#F196A5" />
        <path id="Vector_7" d="M376 511h-14v28h14v-28Z" fill="#FBE9EC" />
        <path id="Vector_8" d="M376 540h-14v28h14v-28Z" fill="#F196A5" />
        <path id="Vector_9" d="M376 568h-14v28h14v-28Z" fill="#FBE9EC" />
      </g>
      <g>
        <path
          id="Vector_10"
          d="M408.5 596H281.463c0 143.878-34.588 278.178-70.463 340h268c-35.912-61.822-70.5-196.122-70.5-340Z"
          fill="#C0D6F6"
        />
        <path
          id="Vector_11"
          d="M295.138 567H134.863c0 156.162-43.5809 301.949-88.8628 369H384c-45.282-67.099-88.862-212.886-88.862-369Z"
          fill="url(#paint2_linear_12981_195183)"
        />
      </g>
      <path
        opacity=".72"
        d="M177 850h278"
        stroke="#81ABEE"
        stroke-width="50"
      />
      <g opacity=".72">
        <rect
          id="Rectangle 2141"
          x="565"
          y="812.011"
          width="10"
          height="76.002"
          rx="5"
          fill="#3D75E4"
        />
        <rect
          id="Rectangle 2152"
          width="10"
          height="76.002"
          rx="5"
          transform="matrix(-1 0 0 1 465 812.011)"
          fill="#3D75E4"
        />
        <path
          id="Rectangle 2142"
          fill="#3D75E4"
          d="M535 825.011h30v50.0013h-30z"
        />
        <path
          id="Rectangle 2153"
          transform="matrix(-1 0 0 1 495 825.011)"
          fill="#3D75E4"
          d="M0 0h30v50.0013H0z"
        />
        <path
          id="Rectangle 2143"
          d="M495 806.01h40v73.003c0 2.761-2.239 5-5 5h-30c-2.761 0-5-2.239-5-5V806.01Z"
          fill="#3D75E4"
        />
        <path
          id="Rectangle 2146"
          d="M507 724.008h16v56.001h-16v-56.001Z"
          fill="#A2ABBE"
        />
        <path
          id="Rectangle 2151"
          d="M511 694.008c0-2.21 1.791-4 4-4s4 1.79 4 4v12h-8v-12Z"
          fill="#A2ABBE"
        />
        <path
          id="Rectangle 2148"
          d="M504 710.008c0-2.21 1.791-4 4-4h14c2.209 0 4 1.79 4 4v4h-22v-4Z"
          fill="#E14761"
        />
        <path
          id="Rectangle 2147"
          d="M466 719.008c0-2.762 2.239-5 5-5h87c2.761 0 5 2.238 5 5 0 2.761-2.239 5-5 5h-87c-2.761 0-5-2.239-5-5Z"
          fill="#E14761"
        />
        <path
          id="Rectangle 2144"
          d="M484 798.01c0-1.104.895-2 2-2h58c1.105 0 2 .896 2 2v4c0 2.209-1.791 4-4 4h-54c-2.209 0-4-1.791-4-4v-4Z"
          fill="#3D75E4"
        />
        <path
          id="Rectangle 2145"
          d="M484 784.01c0-2.209 1.791-4 4-4h53c2.209 0 4 1.791 4 4v4c0 1.104-.895 2-2 2h-57c-1.105 0-2-.896-2-2v-4Z"
          fill="#A2ABBE"
        />
      </g>
      <g>
        <path
          id="Vector_12"
          d="M191 923H0V772.616c0-5.866 6.10518-9.738 11.4116-7.236L99.5 806.911v-34.295c0-5.866 6.105-9.738 11.412-7.236l83.5 39.368c2.801 1.321 4.588 4.139 4.588 7.236V915c0 4.418-3.582 8-8 8Z"
          fill="#81ABEE"
        />
        <path
          id="Rectangle 2157"
          d="M39 868.455C39 858.815 46.8147 851 56.4545 851c3.615 0 6.5455 2.93 6.5455 6.545V923H39v-54.545Z"
          fill="#95B9F2"
        />
        <path
          id="Rectangle 2158"
          d="M87 868.455c0-9.64 7.8147-17.455 17.455-17.455 3.614 0 6.545 2.93 6.545 6.545V923H87v-54.545Z"
          fill="#95B9F2"
        />
        <path
          id="Rectangle 2159"
          d="M135 868.455c0-9.64 7.815-17.455 17.455-17.455 3.614 0 6.545 2.93 6.545 6.545V923h-24v-54.545Z"
          fill="#95B9F2"
        />
      </g>
    </g>
    <g>
      <g class="house">
        <g>
          <path
            id="Rectangle 2133"
            d="M1915.38 281.493c12.81-3.745 25.62 5.856 25.62 19.196V486h-553c-7.18 0-13-5.82-13-13v-20.69c0-7.551 4.98-14.197 12.23-16.317l528.15-154.5Z"
            fill="#FBECDD"
          />
          <path
            id="Rectangle 2124"
            fill="#FBECDD"
            d="M1393 467h527v469h-527z"
          />
          <path id="Vector_13" d="M1650 477v218h229V477h-229Z" fill="#FEFAF6" />
          <path id="Vector_14" d="M1788 541v16h91v-16h-91Z" fill="#FBECDD" />
          <path id="Vector_15" d="M1788 477h-16v218h16V477Z" fill="#FBECDD" />
        </g>
        <g id="ÑÑÑÐ±Ñ_2" stroke="#F8D6B5" stroke-width="20">
          <path id="Vector 961" d="M1564 843h192" />
          <path id="Vector 959_2" d="M1438 936v-71c0-12.15 9.85-22 22-22h25" />
          <path id="Vector 963" d="M1564 761.087h115" />
        </g>
        <g>
          <path
            id="Vector_16"
            d="M1694.02 898.276c13.26 0 24.01-36.596 24.01-81.74s-10.75-81.741-24.01-81.741c-13.27 0-24.02 36.597-24.02 81.741s10.75 81.74 24.02 81.74Z"
            fill="#F8D6B5"
          />
          <path
            id="Vector_17"
            d="M1718.03 898.276c13.26 0 24.02-36.597 24.02-81.741s-10.76-81.74-24.02-81.74-24.01 36.596-24.01 81.74 10.75 81.741 24.01 81.741Z"
            fill="#E9A35D"
          />
          <path
            id="Vector_18"
            d="M1742.06 898.276c13.27 0 24.02-36.597 24.02-81.741s-10.75-81.74-24.02-81.74c-13.26 0-24.01 36.596-24.01 81.74s10.75 81.741 24.01 81.741Z"
            fill="#F8D6B5"
          />
          <path
            id="Vector_19"
            d="M1766.08 898.276c13.26 0 24.01-36.597 24.01-81.741s-10.75-81.74-24.01-81.74c-13.26 0-24.02 36.596-24.02 81.74s10.76 81.741 24.02 81.741Z"
            fill="#E9A35D"
          />
          <path
            id="Vector_20"
            d="M1790.09 898.276c13.27 0 24.02-36.597 24.02-81.741s-10.75-81.74-24.02-81.74c-13.26 0-24.01 36.596-24.01 81.74s10.75 81.741 24.01 81.741Z"
            fill="#F8D6B5"
          />
          <path
            id="Vector_21"
            d="M1814.11 898.276c13.26 0 24.01-36.597 24.01-81.741s-10.75-81.74-24.01-81.74c-13.26 0-24.02 36.596-24.02 81.74s10.76 81.741 24.02 81.741Z"
            fill="#E9A35D"
          />
        </g>
        <g>
          <path
            id="Rectangle 2138"
            fill="#D06E0B"
            d="M1500.17 811.233h15.8855v22.6063H1500.17z"
          />
          <path
            id="Rectangle 2129"
            fill="#E9A35D"
            d="M1479.41 828.435h81.5026v29.6373H1479.41z"
          />
          <path
            id="Rectangle 2139"
            transform="matrix(-1 0 0 1 1563.88 831.399)"
            fill="#E9A35D"
            d="M0 0h11.8549v23.7098H0z"
          />
          <path
            id="Rectangle 2134"
            opacity=".48"
            fill="#D06E0B"
            d="M1547.58 831.399h16.3005v23.7098H1547.58z"
          />
          <path
            id="Rectangle 2135"
            d="M1548.85 826.879c.73-2.585 3.09-4.371 5.77-4.371h2.21c2.68 0 5.04 1.786 5.77 4.371l1.28 4.52h-16.3l1.27-4.52Z"
            fill="#E9A35D"
          />
          <path
            id="Rectangle 2136"
            d="M1562.6 859.629c-.73 2.585-3.09 4.371-5.77 4.371h-2.21c-2.68 0-5.04-1.786-5.77-4.371l-1.27-4.52h16.3l-1.28 4.52Z"
            fill="#D06E0B"
          />
          <path
            id="Rectangle 2132"
            fill="#E14761"
            d="M1500.78 810.011h14.6635v12.2196H1500.78z"
          />
          <path
            id="Rectangle 2130"
            d="M1517.98 805.616c1.08-1.821 3.04-2.937 5.16-2.937h7.69c3.31 0 6 2.686 6 6v7.552c0 3.313-2.69 6-6 6h-22.72l9.87-16.615Z"
            fill="#E14761"
          />
          <path
            id="Rectangle 2137"
            d="M1498.25 805.616c-1.08-1.821-3.04-2.937-5.16-2.937h-7.69c-3.32 0-6 2.686-6 6v7.552c0 3.313 2.68 6 6 6h22.71l-9.86-16.615Z"
            fill="#E14761"
          />
          <rect
            id="Rectangle 2140"
            x="1472"
            y="826.212"
            width="13.3368"
            height="34.0829"
            rx="6"
            fill="#D06E0B"
          />
        </g>
        <g>
          <path
            id="Rectangle 2138_2"
            fill="#D06E0B"
            d="M1500.17 729.554h15.8855v22.6063H1500.17z"
          />
          <path
            id="Rectangle 2129_2"
            fill="#E9A35D"
            d="M1479.41 746.756h81.5026v29.6373H1479.41z"
          />
          <path
            id="Rectangle 2139_2"
            transform="matrix(-1 0 0 1 1563.88 749.72)"
            fill="#E9A35D"
            d="M0 0h11.8549v23.7098H0z"
          />
          <path
            id="Rectangle 2134_2"
            opacity=".48"
            fill="#D06E0B"
            d="M1547.58 749.72h16.3005v23.7098H1547.58z"
          />
          <path
            id="Rectangle 2135_2"
            d="M1548.85 745.2c.73-2.586 3.09-4.371 5.77-4.371h2.21c2.68 0 5.04 1.785 5.77 4.371l1.28 4.52h-16.3l1.27-4.52Z"
            fill="#E9A35D"
          />
          <path
            id="Rectangle 2136_2"
            d="M1562.6 777.95c-.73 2.585-3.09 4.371-5.77 4.371h-2.21c-2.68 0-5.04-1.786-5.77-4.371l-1.27-4.52h16.3l-1.28 4.52Z"
            fill="#D06E0B"
          />
          <path
            id="Rectangle 2132_2"
            fill="#E14761"
            d="M1500.78 728.332h14.6635v12.2196H1500.78z"
          />
          <path
            id="Rectangle 2130_2"
            d="M1517.98 723.937c1.08-1.821 3.04-2.937 5.16-2.937h7.69c3.31 0 6 2.686 6 6v7.551c0 3.314-2.69 6-6 6h-22.72l9.87-16.614Z"
            fill="#E14761"
          />
          <path
            id="Rectangle 2137_2"
            d="M1498.25 723.937c-1.08-1.821-3.04-2.937-5.16-2.937h-7.69c-3.32 0-6 2.686-6 6v7.551c0 3.314 2.68 6 6 6h22.71l-9.86-16.614Z"
            fill="#E14761"
          />
          <rect
            id="Rectangle 2140_2"
            x="1472"
            y="744.533"
            width="13.3368"
            height="34.0829"
            rx="6"
            fill="#D06E0B"
          />
        </g>
      </g>
      <g opacity=".56">
        <path
          id="Vector_22"
          d="M1689 695c0-24.852 20.43-45 45.63-45 25.19 0 45.62 20.148 45.62 45H1689Z"
          fill="#F8D6B5"
        />
        <path
          id="Vector_23"
          d="M1689 694.999c0-13.972 11.56-25.312 25.82-25.312s25.82 11.328 25.82 25.312H1689Z"
          fill="#E9A35D"
        />
        <g id="Group" fill="#E9A35D">
          <path
            id="Vector_24"
            d="M1764.58 695h26.99c0-14.75-12.08-26.719-26.99-26.719-3.72 0-7.27.744-10.5 2.099l10.5 24.62Z"
          />
          <path
            id="Vector_25"
            d="m1780.75 679.48 8.41 5.917 5.95-8.357-14.36 2.44Z"
          />
          <path
            id="Vector_26"
            d="m1772.66 661.25-5.95 8.357 8.41 5.917-2.46-14.274Z"
          />
        </g>
      </g>
      <g>
        <circle id="Ellipse 178" cx="1396" cy="760" r="38" fill="#E1AB76" />
        <circle id="Ellipse 179" cx="1396" cy="755" r="38" fill="#F7E5D5" />
        <circle id="Ellipse 180" cx="1396" cy="779" r="6" fill="#F9F2EB" />
        <rect
          id="Rectangle 2156"
          x="1375"
          y="742"
          width="40"
          height="15"
          rx="4"
          fill="#F9F2EB"
        />
      </g>
    </g>
    <g id="cloud-red" opacity=".56">
      <path
        d="M1273 353c0-60.003-38.06-108.645-85-108.645s-85 48.642-85 108.645h170Z"
        fill="#FBE9EC"
      />
      <path
        d="M1498 353c0-49.68-35.59-89.953-79.5-89.953S1339 303.32 1339 353h159Z"
        fill="#F7CFD5"
      />
      <path
        d="M1407 353c0-69.033-43.65-125-97.5-125s-97.5 55.959-97.5 125h195Z"
        fill="url(#paint3_linear_12981_195183)"
      />
    </g>
    <g id="cloud-blue" opacity=".56">
      <path
        d="M575 312c0-78.422 63.578-142 142-142s142 63.578 142 142H575Z"
        fill="#E4EDFB"
      />
      <path
        d="M418 312c0-62.957 50.811-114 113.5-114 62.68 0 113.5 51.035 113.5 114H418Z"
        fill="url(#paint4_linear_12981_195183)"
      />
      <path
        opacity=".72"
        d="M561 312c0-44.736 36.04-81 80.5-81s80.5 36.264 80.5 81H561Z"
        fill="#C0D6F6"
      />
    </g>
    <g id="vertical-dots" opacity="0.56">
<path class="dots__second" d="M503 475.823C503 480.242 506.582 483.823 511 483.823C515.418 483.823 519 480.242 519 475.823C519 471.405 515.418 467.823 511 467.823C506.582 467.823 503 471.405 503 475.823Z" fill="#81ABEE"/>
<path class="dots__first" d="M471 451.525C471 455.943 474.582 459.525 479 459.525C483.418 459.525 487 455.943 487 451.525C487 447.107 483.418 443.525 479 443.525C474.582 443.525 471 447.107 471 451.525Z" fill="white"/>
<path class="dots__first" d="M471 476C471 480.418 474.582 484 479 484C483.418 484 487 480.418 487 476C487 471.582 483.418 468 479 468C474.582 468 471 471.582 471 476Z" fill="#81ABEE"/>
<path class="dots__first" d="M471 403C471 407.418 474.582 411 479 411C483.418 411 487 407.418 487 403C487 398.582 483.418 395 479 395C474.582 395 471 398.582 471 403Z" fill="#E4EDFB"/>
<path class="dots__second" d="M503 403C503 407.418 506.582 411 511 411C515.418 411 519 407.418 519 403C519 398.582 515.418 395 511 395C506.582 395 503 398.582 503 403Z" fill="#FBE9EC"/>
<path class="dots__first" d="M471 323C471 327.418 474.582 331 479 331C483.418 331 487 327.418 487 323C487 318.582 483.418 315 479 315C474.582 315 471 318.582 471 323Z" fill="#C0D6F6"/>
<path class="dots__second" d="M503 323C503 327.418 506.582 331 511 331C515.418 331 519 327.418 519 323C519 318.582 515.418 315 511 315C506.582 315 503 318.582 503 323Z" fill="#81ABEE"/>
<path class="dots__first" d="M471 291C471 295.418 474.582 299 479 299C483.418 299 487 295.418 487 291C487 286.582 483.418 283 479 283C474.582 283 471 286.582 471 291Z" fill="#F7CFD5"/>
<path class="dots__first" d="M471 671C471 675.418 474.582 679 479 679C483.418 679 487 675.418 487 671C487 666.582 483.418 663 479 663C474.582 663 471 666.582 471 671Z" fill="#F7CFD5"/>
<path class="dots__first" d="M471 639C471 643.418 474.582 647 479 647C483.418 647 487 643.418 487 639C487 634.582 483.418 631 479 631C474.582 631 471 634.582 471 639Z" fill="#C0D6F6"/>
<path class="dots__first" d="M471 615C471 619.418 474.582 623 479 623C483.418 623 487 619.418 487 615C487 610.582 483.418 607 479 607C474.582 607 471 610.582 471 615Z" fill="#E4EDFB"/>
<path class="dots__second" d="M503 590.525C503 594.943 506.582 598.525 511 598.525C515.418 598.525 519 594.943 519 590.525C519 586.107 515.418 582.525 511 582.525C506.582 582.525 503 586.107 503 590.525Z" fill="#E4EDFB"/>
<path class="dots__second" d="M503 615C503 619.418 506.582 623 511 623C515.418 623 519 619.418 519 615C519 610.582 515.418 607 511 607C506.582 607 503 610.582 503 615Z" fill="#F7CFD5"/>
<path class="dots__first" d="M471 558.451C471 562.869 474.582 566.451 479 566.451C483.418 566.451 487 562.869 487 558.451C487 554.032 483.418 550.451 479 550.451C474.582 550.451 471 554.032 471 558.451Z" fill="#F7CFD5"/>
<path class="dots__second" d="M503 539.863C503 544.282 506.582 547.863 511 547.863C515.418 547.863 519 544.282 519 539.863C519 535.445 515.418 531.863 511 531.863C506.582 531.863 503 535.445 503 539.863Z" fill="#81ABEE"/>
<path class="dots__first" d="M471 507.737C471 512.156 474.582 515.737 479 515.737C483.418 515.737 487 512.156 487 507.737C487 503.319 483.418 499.737 479 499.737C474.582 499.737 471 503.319 471 507.737Z" fill="#E4EDFB"/>
<path class="dots__second" d="M503.08 476C503.08 480.418 506.661 484 511.08 484C515.498 484 519.08 480.418 519.08 476C519.08 471.582 515.498 468 511.08 468C506.661 468 503.08 471.582 503.08 476Z" fill="white"/>
<path class="dots__second" d="M503.08 452C503.08 456.418 506.661 460 511.08 460C515.498 460 519.08 456.418 519.08 452C519.08 447.582 515.498 444 511.08 444C506.661 444 503.08 447.582 503.08 452Z" fill="#F7CFD5"/>
<path class="dots__second" d="M503 371C503 375.418 506.582 379 511 379C515.418 379 519 375.418 519 371C519 366.582 515.418 363 511 363C506.582 363 503 366.582 503 371Z" fill="#81ABEE"/>
<path class="dots__first" d="M471 347.525C471 351.943 474.582 355.525 479 355.525C483.418 355.525 487 351.943 487 347.525C487 343.107 483.418 339.525 479 339.525C474.582 339.525 471 343.107 471 347.525Z" fill="#F7CFD5"/>
</g>
    <g id="dots2" opacity=".56">
      <path
        class="dots2__second-line"
        d="M1344 539.702c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#81ABEE"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 564c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#fff"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 587.702c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#E4EDFB"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 620c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#81ABEE"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 668c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#E4EDFB"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 692.525c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#F7CFD5"
      />
      <path
        class="dots2__second-line"
        d="M1344.08 724.525c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#C0D6F6"
      />
      <path
        class="dots2__first-line"
        d="M1312 369c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#81ABEE"
      />
      <path
        class="dots2__first-line"
        d="M1312 337c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#fff"
      />
      <path
        class="dots2__first-line"
        d="M1312 400.6c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#F7CFD5"
      />
      <path
        class="dots2__first-line"
        d="M1344 425c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#fff"
      />
      <path
        class="dots2__first-line"
        d="M1312 425c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#F7CFD5"
      />
      <path
        class="dots2__first-line"
        d="M1344 457.074c0-4.418-3.58-8-8-8s-8 3.582-8 8c0 4.419 3.58 8 8 8s8-3.581 8-8Z"
        fill="#F7CFD5"
      />
      <path
        class="dots2__first-line"
        d="M1312 475.662c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#81ABEE"
      />
      <path
        class="dots2__first-line"
        d="M1312 507.788c0-4.419-3.58-8-8-8s-8 3.581-8 8c0 4.418 3.58 8 8 8s8-3.582 8-8Z"
        fill="#E4EDFB"
      />
      <path
        class="dots2__first-line"
        d="M1312 564c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#F7CFD5"
      />
      <path
        class="dots2__first-line"
        d="M1312 620c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#E4EDFB"
      />
      <path
        class="dots2__first-line"
        d="M1312 668c0-4.418-3.58-8-8-8s-8 3.582-8 8 3.58 8 8 8 8-3.582 8-8Z"
        fill="#F7CFD5"
      />
    </g>
    <path id="Vector_71" d="M-2 923v37h1923v-37H-2Z" fill="#E4EDFB" />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_12981_195183"
      x1="983"
      y1="728.5"
      x2="822"
      y2="728.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F7E9DD" />
      <stop offset=".703125" stop-color="#F7CFD5" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_12981_195183"
      x1="329.983"
      y1="317.674"
      x2="250.016"
      y2="487.91"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D4E2F7" />
      <stop offset="1" stop-color="#E4EDFB" stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_12981_195183"
      x1="374.683"
      y1="751.499"
      x2="65.6132"
      y2="751.499"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#98BAF1" />
      <stop offset="1" stop-color="#E5EEFF" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_12981_195183"
      x1="1212"
      y1="290.498"
      x2="1407"
      y2="290.498"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FEF8F9" />
      <stop offset="1" stop-color="#F7CFD5" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_12981_195183"
      x1="647.051"
      y1="255.003"
      x2="422.01"
      y2="255.003"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F6F9FE" />
      <stop offset="1" stop-color="#C0D6F6" />
    </linearGradient>
    <clipPath id="clip0_12981_195183">
      <path fill="#fff" d="M0 0h1920v960H0z" />
    </clipPath>
  </defs></svg
>`;
